// extracted by mini-css-extract-plugin
export default {"menuPageHeader":"menu-page-common_menuPageHeader__Hj2kP","container":"menu-page-common_container__0dzg7"};